import React from 'react'
import { SigurModalSearch } from "../lib/SigurModalSearch";
import AttrInput from '../smart_bps/lib/attr_input'
import { split_list } from '../smart_bps/lib/utils'

/** Модалка поиска без кнопки «Сохранить в отбор». */
export class AccessObjectsModalSearch extends SigurModalSearch {
    render() {
    const that = this;
    const state = this.state
    const data = state.data

    function render_attr(attr) {
      const raw = data[attr.name]
      const digits = raw != null && raw !== '' ? String(raw).replace(/\D/g, '').slice(0, 10) : ''
      const display =
        digits.length === 0
          ? ''
          : digits.length <= 4
            ? digits
            : `${digits.slice(0, 4)} ${digits.slice(4)}`
      return attr.name === 'passport'
        ? (
          <div key={attr.name} className="mb-2">
            <label className="form-label">{attr.title}{' '}</label>
            <input
              type="text"
              className={`form-control ${attr.error ? 'is-invalid' : ''}`}
              inputMode="numeric"
              autoComplete="off"
              placeholder="0000 000000"
              maxLength={11}
              value={display}
              onChange={(e) => {
                const d = e.target.value.replace(/\D/g, '').slice(0, 10)
                const v = d.length === 0 ? null : d.length === 10 ? parseInt(d, 10) : d

                that.setState((prevState) => {
                  const newData = { ...prevState.data }

                  if (v === null || v === '') {
                    delete newData.passport
                  } else {
                    newData.passport = v
                  }

                  return { data: newData }
                })
              }}
            />
          </div>
        )
        : (
          <AttrInput
            key={attr.name}
            data_type={attr.data_type}
            widget={attr.widget}
            name={attr.name}
            title={attr.title}
            value={data[attr.name]}
            choice_name={attr.choice_name}
            choices={that.props.choices}
            inner_attrs={attr.inner_attrs}
            access="edit"
            onChange={that.onChange}
          />
        )
    }

    function renderGroup(item, idx) {
      let group_title = item[0]
      let attrs = item[1]

      return <div key={idx}>
        {group_title && <div className="divider my-2">
          <div className="divider-text"><strong>{group_title}</strong></div>
        </div>}
        <div className="row">
          {split_list(attrs, 3).map((attrs, idx1) => {
            return <div className="col-md-4" key={idx1}>
              {attrs.map(render_attr)}
            </div>
          })}
        </div>
      </div>
    }

    return (
      <div className="modal fade" id="modal_search" tabIndex="-1" style={{ display: "none" }} aria-hidden="true">
        <div className="modal-dialog modal-xl" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel1">Поиск по параметрам</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              {that.props.schema.map(renderGroup)}
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-primary p-2 me-1" onClick={this.onSearch}>
                <span className="ti ti-search me-1"></span>
                Найти
              </button>
              <button type="button" className="btn btn-warning p-2 me-1" onClick={this.onClean}>
                <span className="ti ti-x me-1"></span>
                Сброс
              </button>
              <button type="button" className="btn btn-secondary p-2 me-1" data-bs-dismiss="modal">
                Закрыть
              </button>
              {this.renderSaveSearch()}
            </div>
          </div>
        </div>
      </div>
    )
  }
}